import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { ButtonClose, NoDataContent } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../TitlePage/TitlePage';
import { CSSProperties } from 'react';
import { MoonLoader } from 'react-spinners';
import './ModalComponent.scss';

interface ModalComponentProps {
    title: string;
    onClose: (isOpen?: any) => void;
    child: React.ReactElement;
    childHeader?: React.ReactElement;
    style?: CSSProperties;
    styleContent?: CSSProperties;
    loading?: boolean,
    isNoData?: boolean,
    titleNoData?: string,
    descriptionNoData?: string,
    right?: boolean
}

const ModalComponent: FC<ModalComponentProps> = ({
    title,
    onClose = () => { },
    child,
    childHeader,
    style = {},
    styleContent = {},
    loading = false,
    isNoData = false,
    titleNoData = '',
    descriptionNoData = '',
    right = false
}) => {

    return createPortal(
        <div className="blackout"
            onClick={(e) => {
                let el = e.target as HTMLElement;
                if (el.classList.contains('blackout')) {
                    onClose()
                }
            }}
        >
            <div className={right ? 'modal-component-right' : 'modal-component'} style={style}>
                {title && <header className='modal-component__header'>
                    <TitlePage
                        title={title}
                    />

                    {childHeader}

                    <ButtonClose
                        onClick={onClose}
                    />
                </header>}

                <div className='modal-component__content' style={styleContent}>
                    {(loading)
                        ?
                        <div className='modal-component__loader'>
                            <MoonLoader
                                size={40}
                                color="#7b7b7b"
                                speedMultiplier={0.5}
                            />
                        </div>
                        :
                        (!isNoData ? child : null)
                    }

                    {(isNoData && !loading) &&
                        <NoDataContent
                            title={titleNoData || 'Нет данных'}
                            description={descriptionNoData}
                            height='100%'
                        />}
                </div>
            </div>
        </div>,
        document.body
    );
};

export { ModalComponent };